import Repository from '../Repository';

const url = '/gym';

export default {
    getVideos(page, type = 'newest') {
        return Repository.get(`${url}/videos?page=${page}&type=${type}`, {localLoading: true});
    },
    searchVideos(query) {
        return Repository.get(`${url}/videos?q=${query}`, {localLoading: true});
    },
    getFilteredVideos(filter) {
        return Repository.post(`${url}/videos/filtered`, filter, {localLoading: true});
    },
    getVideo(id) {
        return Repository.get(`${url}/videos/${id}`, {localLoading: true});
    },
    toggleFavorVideo(id) {
        return Repository.get(`${url}/videos/${id}/favor`, {dont_append_to_loading_stack: true});
    },
    updateViewProgress(id, seconds) {
        return Repository.post(`${url}/videos/${id}/update-view-progress`,  {
            seconds: seconds
        },{
            dont_append_to_loading_stack: true,
            hide_progress_bar: true,
        });
    }
}
